import {Component, Input, ViewEncapsulation} from '@angular/core';
import {ReportTableRowParametersMetricsStore} from './report-table-row-parameters-metrics.store';
import {Observable} from 'rxjs';
import {MetricComponentObject, MetricComponentObjects} from '../../../../../../shared/classes/metric-component-object';
import {map} from 'rxjs/operators';
import {Serializer} from '../../../../../../shared/interfaces/serializer';
import {DataSetMetric} from '../../../../../../shared/interfaces/metrics';
import {SavedReportComponentObject} from '../../../../../../shared/classes/saved-report-component-object';

@Component({
  selector: 'app-report-table-row-parameters-metrics',
  templateUrl: './report-table-row-parameters-metrics.component.html',
  styleUrls: ['./report-table-row-parameters-metrics.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ReportTableRowParametersMetricsStore]
})
export class ReportTableRowParametersMetricsComponent {
  @Input('report') public set report(report: SavedReportComponentObject) {
    if (report.payload.attributes.report_type === 'cycle') {
      this._reportCardParametersMetricsStore.patchState({ enable: false });
    }
  };

  @Input('parameter') public set parameter(metrics: Array<string> | null | undefined) {
    if (metrics) {
      this._reportCardParametersMetricsStore.init(metrics);
    }
  };

  public readonly metrics$: Observable<MetricComponentObjects> = this._reportCardParametersMetricsStore.metrics$;

  public readonly metric$: Observable<Serializer<DataSetMetric>> = this._reportCardParametersMetricsStore.metric$
    .pipe(map((metric: MetricComponentObject): Serializer<DataSetMetric> => metric?.payload as Serializer<DataSetMetric>));

  public readonly numberOfMetric$: Observable<number> = this._reportCardParametersMetricsStore.numberOfMetrics$;
  public readonly enable$: Observable<boolean> = this._reportCardParametersMetricsStore.enable$;

  constructor(
    private readonly _reportCardParametersMetricsStore: ReportTableRowParametersMetricsStore
  ) {
  }
}
